<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="contact" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>Contact GB Wave</h1>
      <p>
        We welcome your feedback, questions, and suggestions. If you have any concerns about our website content, encounter an issue, or want to share suggestions, feel free to contact us.
      </p>
      <p>You can contact us for:</p>
      <ul>
        <li>Website feedback</li>
        <li>Content updates</li>
        <li>Copyright-related requests</li>
        <li>General questions</li>
      </ul>
      <p>We will review your message and respond as soon as possible.</p>
      <p>Email:</p>
      <p><a href="mailto:support@gb-wave.com">support@gb-wave.com</a></p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'ContactPage',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Contact', current: true },
      ],
    };
  },
};
</script>
